// extracted by mini-css-extract-plugin
export default {"fabContainer":"FloatingActionButton_fabContainer__sD+05","fab":"FloatingActionButton_fab__MJ2HY"};